<!-- 报告信息组件 -->
<template>
    <div class="pageContent">
        <CommonRow :title="$t('page.reportInfo.reportName')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ reportInfo.name || "-" }}</div>
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.reportInfo.uploadTime')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ reportInfo.uploadingTime || "-" }}</div>
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.reportInfo.reportRemark')">
            <div class="whiteCard">
                <div class="whiteCardText">{{ reportInfo.remark || "-" }}</div>
            </div>
        </CommonRow>
        <CommonRow :title="$t('page.reportInfo.reportImage')">
            <template v-if="reportInfo.image">
                <div class="parkImgBox">
                    <CommonImageCard v-for="(item, index) in reportInfo.image.split(',')" :key="index" :src="handleImage(item) || ''"
                        :width="'89px'" :height="'126px'" />
                </div>
            </template>
            <template v-else>
                <CommonEmpty :description="$t('empty.noReportImage')" />
            </template>
        </CommonRow>
    </div>
</template>

<script>
import CommonImageCard from '../common/commonImageCard.vue';
import { CODE_SUCCESS } from '../../utils/constant.js';
import { validateImageUrl } from '../../utils/index';
export default {
    components: {
        CommonImageCard,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            reportInfo: {}, // 报告信息
        };
    },
    methods: {
        async refresh() {
            if (!this.info.reportId) {
                this.reportInfo = {};
                return
            }
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    id: this.info.reportId
                }
                const res = await this.$api.fetchZdFarmReportById(params);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.reportInfo = res.data || {};
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        handleImage(image) {
            return validateImageUrl(image);
        },
    },
};
</script>

<style scoped>
.farmBox {
    width: 100%;
    height: auto;
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    column-gap: 21px;
    row-gap: 12px;
}

.parkImgBox {
    width: 100%;
    height: auto;
    display: flex;
    column-gap: 8px;
    overflow: hidden;
    overflow-x: auto;
    padding-bottom: 10px;
}
</style>